export const deviceStorage: any = {
    "cookie": {
        getItem: (key: string): string => {
            const cookies = document.cookie.split(";").map(cookie => cookie.trim());
            for (const cookie of cookies) {
                const [cookieName, cookieValue] = cookie.split("=");
                if (cookieName === key) {
                    return decodeURIComponent(cookieValue);
                }
            }
            return ""
        },
        setItem: (key: string, value: string, daysToExpire: number = 30): string => {
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + daysToExpire);

            const cookieValue = encodeURIComponent(value) + (daysToExpire ? `; expires=${expirationDate.toUTCString()}` : '');
            document.cookie = `${key}=${cookieValue}; path=/`;
            return key;
        },
        removeItem: (key: string): string => {
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() - 1); // Đặt hạn sử dụng là hôm qua

            const cookieValue = encodeURIComponent("") + "; expires=" + expirationDate.toUTCString();
            document.cookie = key + "=" + cookieValue + "; path=/";
            return key;
        },
        flush: () => {
            const cookies = document.cookie.split(";");

            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i];
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            }
        }
    },
    "session": {
        getItem: (key: string): string => {
            return sessionStorage.getItem(key) || "";
        },
        setItem: (key: string, value: string): string => {
            sessionStorage.setItem(key, value)
            return key;
        },
        removeItem: (key: string): string => {
            sessionStorage.removeItem(key)
            return key;
        },
        flush: () => {
            sessionStorage.clear();
        }
    },
    "local": {
        getItem: (key: string): string => {
            return localStorage.getItem(key) || "";
        },
        setItem: (key: string, value: string): string => {
            localStorage.setItem(key, value)
            return key;
        },
        removeItem: (key: string): string => {
            localStorage.removeItem(key)
            return key;
        },
        flush: () => {
            localStorage.clear();
        }
    }
}